export default __webpack_public_path__ + "static/media/metamask.9b2aa24e.svg";